import { Component, OnInit } from "@angular/core";
import { first } from "rxjs/operators";
import { Router } from "@angular/router";
import { from, Observable } from "rxjs";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { TopBarMenu } from "../top-bar/top-bar-menu";
import { NavBarHorizontalComponent } from "../nav-bar-horizontal/nav-bar-horizontal.component";

@Component({
  selector: "app-top-bar-parametrage",
  templateUrl: "./top-bar-parametrage.component.html",
  styleUrls: ["./top-bar-parametrage.component.scss"],
  animations: [
    trigger("slide", [
      state("up", style({ height: 0 })),
      state("down", style({ height: "*" })),
      transition("up <=> down", animate(200)),
    ]),
  ],
})
export class TopBarParametrageComponent implements OnInit {
  currentEmployee1: Employee = new Employee();

  MyPermissions1: string[];

  menus1 = [];

  constructor(
    private _router: Router,
    private _topBarService: TopBarMenu,
    private _keycloakService: KeycloakService,
    private _employeeService: EmployeeService,
    private _navBarHorizontalComponent: NavBarHorizontalComponent
  ) {
    this.getCurrentEmployee();
    this.menus1 = _topBarService.getMenuList();
    this.MyPermissions1 = _keycloakService.getAccessPermissions();
  }

  ngOnInit() {
    this._topBarService.toggleActiveLink();
  }

  getCurrentEmployee() {
    this._employeeService.getCurrentEmployee().subscribe(
      (data) => {
        this.currentEmployee1 = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  toggle(code, url) {
    localStorage.setItem("current_menu_header", code);
    this.redirectUrl(url);
  }

  logout() {
    
    localStorage.setItem("current_menu_header", "new_tableau_de_bord");
    localStorage.setItem("current_menu_header_changed", "true");
    this._navBarHorizontalComponent.clearMenu("new_tableau_de_bord");

    this.redirectUrl("/").then(() => {
      this._keycloakService.logout().subscribe({
        next: () => {
          console.log("Déconnexion réussie");
        },
        error: (error) => {
          console.error("Erreur lors de la déconnexion :", error);
        },
      });
    });
  }
  
  redirectUrl(url: string): Promise<boolean> {
    return this._router.navigate([url]).then((success) => {
      if (success) {
        window.location.reload();
      }
      return success;
    });
  }

}
